<template>
  <div
    class="row q-col-gutter-sm"
    v-bind="$attrs"
  >
    <div
      v-for="(file, key) in files"
      :key="key"
      class="col-12 col-sm-6"
    >
      <file-view-card
        :file="file"
        :preview-height="40"
        read-only
        without-title
        clickable
        class="full-height"
        @details="viewingFileID = file.id"
      />
    </div>
  </div>

  <ViewFileDialog
    v-if="viewingFileID"
    :id="viewingFileID"
    preview
    @close="viewingFileID = null"
  />
</template>

<script>
import ViewFileDialog from 'components/app/files/partials/view/Dialog.vue'

export default {
  components: { ViewFileDialog },
  props: {
    files: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      viewingFileID: null
    }
  }
}
</script>
